import { createVanIconComponent } from "./van"

const BrowsingHistory = createVanIconComponent("browsing-history")
export default BrowsingHistory
